import type { ComponentProps } from 'react';

import ChevronRight from '@/public/icons/chevron-left.svg';
import { twMerge } from '@/tailwind-merge.config';

export const IconChevronRight = ({ ...props }: ComponentProps<'svg'>) => {
  const { className, ...restProps } = props;
  return (
    <ChevronRight className={twMerge('rotate-180', className)} {...restProps} />
  );
};
